let store = null
let router = null

export function setHttpContext(vueStore, vueRouter) {
  store = vueStore
  router = vueRouter
}

export function getHttpContext() {
  return { store, router }
}
